import React from "react";
import { useCompteLoginCreateMutation } from "../../../redux/slice/api/FO/compteApi";
//import { Button } from "react-bootstrap";
import {SubmitHandler } from "react-hook-form";
import { IFormUtilisateur } from "../../../models/interfaces/IFormUtilisateur";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import UtilisateurInformationsPersonnel from "./UtilisateurInformationsPersonnel";
import { Tab, Tabs } from "react-bootstrap";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";



const PageNouvelUtilisateur: React.FC = () => {

  const navigate = useNavigate();

  const [
    createCompte
    //{
    //isSuccess: isSuccessCreateCompte,
    //error: errorCreateCompte,
  //}
] = useCompteLoginCreateMutation();

  
const onSubmitUtilisateur: SubmitHandler<IFormUtilisateur> = async (data) => {
  try {
    const response = await createCompte({
      ...data,
      Login: data.Email,
    }).unwrap();

    if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      response.Return_Message 
      ? toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000})
      : toast.error(<div dangerouslySetInnerHTML={{ __html: "La création n'a pas été pris en compte" }} />,{autoClose:5000});
    } else if (!isNaN(Number(response?.Compte.Id))) {
      toast.success(<div dangerouslySetInnerHTML={{ __html: "La création à bien été pris en compte" }} />);
      navigate(`/utilisateurmodif/${response?.Compte?.Id}`, { replace: true });
    }
 
  } catch (error) {
    console.error('Erreur lors de la création du compte :', error);
  }
};

return (
  <>
        <div className="container text-center">
          <div className="row pt-3 pb-5">
            <div className="col col-12 ">
              <h2 className="titreModule titre-bleu"><i className="bi-person pe-2" />Utilisateur</h2>
            </div>
          </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
            <Tabs defaultActiveKey="infos" id="uncontrolled-tab-example" className="onglet mb-3">
              <Tab eventKey="infos" title="Informations générales">
                <UtilisateurInformationsPersonnel Compte={undefined} disableEmail={false} handleEnregistrer={onSubmitUtilisateur} ReadOnlyServicePart={true} />
              </Tab>
            </Tabs>
          </div>
        </div>
    </div>
  </>
)

}; 

export default PageNouvelUtilisateur;

